import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TUnifiedLoginAppsEnvironmentVars } from '@monorepo/types';
import { PushNotificationService } from '../capacitor/push-notification.service';
import { UnifiedLoginEnvService } from './unified-login-env.service';
import { TInvlidateLoginAPIRequestDTO, TRESPONSE_Verify_Token } from './unified-login.types';
import { URL_UTILS } from '@monorepo/utils';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UnifiedLoginDataService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(
    public http: HttpClient,
    private envProvider: UnifiedLoginEnvService,
    private pushNotifService: PushNotificationService,
  ) {}

  getLoginRedirectURL(loginSource: string) {
    let path = window.location.pathname === '/' ? '/?dev=true' : window.location.pathname;
    if (this.envProvider.mode === 'dev') {
      path += '&isLocal=true'; //param added to identify app running locally
    }
    const url = this.envProvider.getEnvVar('UNIFIED_ID_LOGIN_REDIRECT') + URL_UTILS.encodeUrlQueryParamValue(path);

    return `${url}&loginSource=${loginSource}`;
  }

  async fetchUserByLoginProxy<T extends TUnifiedLoginAppsEnvironmentVars['appType']>(appType: T, loginProxy: string) {
    const deviceToken = await this.pushNotifService.getDeviceToken();
    const url = this.envProvider.getEnvVar('FETCH_USER_BY_LOGIN_PROXY');
    console.log('[unifiedloginProxy] Device token sent to unifiedloginProxy =>', deviceToken);
    const data = { loginProxy, loginSource: appType, ...(deviceToken && { fcmToken: deviceToken }) };
    console.log('[unifiedloginProxy] Data sent to unifiedloginProxy =>', data);
    return lastValueFrom(this.http.post<TRESPONSE_Verify_Token>(url, data, this.httpOptions));
  }

  async invalidateSecurityKey(params: TInvlidateLoginAPIRequestDTO) {
    const deviceToken = await this.pushNotifService.getDeviceToken();
    const url = this.envProvider.getEnvVar('INVALIDATE_SECURITY_KEY');
    this.pushNotifService.getDeviceToken();
    console.log('[invalidateSecurityKey] Device token sent to unifiedloginProxy =>', deviceToken);
    const data = { ...params, ...(deviceToken && { fcmToken: deviceToken }) };
    console.log('[invalidateSecurityKey] Data sent to unifiedloginProxy =>', data);
    return lastValueFrom(this.http.post(url, data, this.httpOptions));
  }
}
